<footer class="footer-area text-center bg-white border-top-radius"
    [class.card-borderd-theme]="themeService.isCardBorder()" [class.component-dark-theme]="themeService.isDark()">
    <p class="mb-0 footer-text">
        © <span class="text-black fw-medium">Ama Kalakara</span> is Proudly Owned by <a
            href="https://amakalakara.odisha.gov.in/" target="_blank">OLLC DEPARTMENT, Govt. Of Odisha</a>
    </p>
</footer>